import api from '@/utils/api';

/**
 * Get all users
 * @param {string} filter - filter
 * @returns {Promise}
 */
const getUsersApi = (filter) => api.get(`user?${filter}`);

export default getUsersApi;
